<template>
	<div ref="iframeContainer" class="player-wrapper iframe-container max-w-[100%] relative" :style="elWidth">
		<EwLoadingOverlay v-if="loading || !hasIframeSrc" />
		<iframe
			v-if="hasIframeSrc"
			ref="iframe"
			:src="iframeSrc"
			@load="onIframeLoad"
		>
		</iframe>
	</div>
</template>

<script setup lang="ts">
import { computed, inject, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import {SetEditingContextFn} from '@/types';

import { useResizeObserver } from '@vueuse/core'
import EwLoadingOverlay from './EwLoadingOverlay.vue';

const iframeContainer = ref()
const elWidth = ref({ '--cw': '0px' })
function updateSize() {
  elWidth.value['--cw'] = iframeContainer.value.offsetWidth + 'px'
}

useResizeObserver(iframeContainer, () => {
  updateSize()
})
function onIframeLoad() {
  loading.value = false;
}


const setEditingContext = inject(SetEditingContextFn)

const loading = ref( false );


// Accept the initial iframe src value as a prop
const props = defineProps<{
	initialIframeSrc?: string;
}>();

const iframeSrc = computed(() => String(props.initialIframeSrc ?? '').trim())
const hasIframeSrc = computed(() => iframeSrc.value !== '')
const iframe = ref<HTMLIFrameElement | null>(null);

watch(iframeSrc, (nextSrc) => {
	loading.value = nextSrc !== ''
}, { immediate: true })

onMounted(() => {
  // Listen for messages from the iframe
  window.addEventListener('message', handleMessage, false);
});
// Handle messages from the iframe
function handleMessage(event: MessageEvent) {
  // You can check event.origin if you want to verify the sender
  if ( setEditingContext && event.data.type === 'open-edit-tool' && event.data.data?.url ) {
	setEditingContext(event.data.data.url, 'podcast', event.data.data.url, 'Presentation')
    const data = event.data;
    console.log('Message received from iframe:', data);
  }
}
// Cleanup listener on component unmount
onBeforeUnmount(() => {
  window.removeEventListener('message', handleMessage);
});
</script>

<style scoped>
/* @media only screen and (min-width: 576px) {
	.player-wrapper {
		height: 80vh;
	}
}
@media only screen and (max-width: 575px) {
	.player-wrapper {
		height: 70vh;
	}
} */
.iframe-container {
  height: calc((var(--cw) - 336px) * 9 / 16);
}

.iframe-container iframe {
  width: 100%;
  height: 100%!important;
  position: static;
}

@media screen and (max-width: 896px) {
  .iframe-container {
    height: 80vh;
  }
}
@media screen and (max-width: 1350px) {
	.ew-media-player .video-js .vjs-text-track-display .vjs-text-track-cue {
		font-size: 100% !important;
	}
}
@media screen and (max-width: 896px) {
	.ew-media-player .video-js .vjs-text-track-display .vjs-text-track-cue {
		font-size: 75% !important;
	}
}

</style>
